import { myAxios } from "./axios"

export function getInvoiceables({contractId, with_invoice}, { page, perPage }) {
    let config = {
        params: {
            page,
            perPage,
            with_invoice
        },
    }
    return myAxios.get("/company-contracts/"+contractId+"/invoiceables", config)
}


export function getInvoiceable(id) {
    return myAxios.get("/invoiceables/" + id)
}

export function addInvoiceable(data) {
    return myAxios.post("/invoiceables/create", data)
}

export function editInvoiceable(id, data) {
    return myAxios.put("/invoiceables/" + id + "/update", data)
}

export function deleteInvoiceable(id) {
    return myAxios.delete("/invoiceables/" + id + "/delete")
}


